import { AloftDate, AloftPrice, PAIRED_SALES_API } from '@aloft/toolkit-shared';

import { InitialStudy } from '../../modules/adjustPairedSalesStandalone/types.js';
import { AddStudy } from '../../modules/studies/hooks/useAddStudyForm.js';
import { useStudiesState } from '../hooks/useStudiesState.js';

export function getInitialStudy(
  modalInput: AddStudy | null,
  studyID: string | undefined,
  studiesResponse: ReturnType<typeof useStudiesState>['studies']['data'],
): InitialStudy {
  const isNewStudyFromModal = !!modalInput;

  // If we're creating a new study from the modal, use the input from the modal
  // and provide default body values
  if (isNewStudyFromModal) {
    const input: InitialStudy['input'] =
      modalInput.analysisFeature === 'custom'
        ? {
            propertyType: modalInput.propertyType,
            mlsID: modalInput.mlsID,
            analysisFeature: {
              t: 'custom',
              name: modalInput.customAnalysisFeatureName,
            },
          }
        : modalInput;

    return {
      input,
      body: {
        search: {
          filters: {
            propertySubType: ['Single Family Residence'],
            saleDate: {
              min: AloftDate.today().subtractDays(365),
              max: AloftDate.today(),
            },
            salePrice: {
              min: AloftPrice.fromDollarLike(20000),
              max: undefined,
            },
          },
          pairCriteria: {
            version: 1,
            matchCriteria: {
              propertySubType: { t: 'equal' },
              saleDate: { t: 'withinUnit', value: 180 },
            },
            differenceCriteria: { p1: { t: 'any' }, p2: { t: 'any' } },
          },
          geoSearch: {
            t: 'polygon',
            coords: [],
          },
        },
        reconciledValue: undefined,
        notes: '',
        selectedPairs: [],
      },
    };
  }

  const studies = PAIRED_SALES_API.GET.RESPONSE.parse(studiesResponse).results ?? [];
  const savedStudy = studies.find((x) => x.id === studyID);

  if (!savedStudy) {
    throw new Error(`No study with ID ${studyID} exists and no input was provided.`);
  }

  return savedStudy;
}
